import { palette } from '../../../'

import Tab from '@mui/material/Tab'
import { styled } from '@mui/material/styles'
import { NavLink } from 'react-router-dom'

const HeaderLinkStyles = () => {
  return {
    '&': {
      color: palette?.black?.plus50,
      boxShadow: `inset 0px 0px 0px 0px ${palette?.black?.plus100 ?? 'white'}`,
      padding: '20px 24px',
      textDecoration: 'none',
      fontWeight: '600',
      fontSize: '16px',
      transition: 'color .2s ease, box-shadow .2s ease',
    },
    '&.selected': {
      color: palette?.black?.plus10,
      boxShadow: `inset 0px -4px 0px 0px ${palette?.black?.plus10 ?? 'black'}`,
    },
  }
}

const HeaderLinkStyled = styled(NavLink)(() => HeaderLinkStyles)
const TabStyled = styled(Tab)(() => HeaderLinkStyles)

export { HeaderLinkStyled, TabStyled }
